import React from "react";

import { Separator, Stack, useTheme } from "@bps/fluent-ui";
import { PltUser } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { PermissionsAndRoles } from "./PermissionsAndRoles";
import { UserAuthSettings } from "./UserAuthSettings";

interface PltUsersRowExpandProps {
  user: PltUser;
}

export const PltUsersRowExpand: React.FC<PltUsersRowExpandProps> = ({
  user
}) => {
  const theme = useTheme();

  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      tokens={{ padding: theme.spacing.m, childrenGap: theme.spacing.m }}
    >
      <Stack.Item grow styles={{ root: { flexBasis: 0 } }}>
        <PermissionsAndRoles user={user} />
      </Stack.Item>
      <Separator vertical />
      <Stack grow styles={{ root: { flexBasis: 0 } }}>
        <UserAuthSettings user={user} />
      </Stack>
    </Stack>
  );
};
